import React from 'react';
import {connect} from "react-redux";
import {Card, CardBody} from "reactstrap";

import APIForm2 from "../../Components/APIForm2";
import AppHeader from "../../Layout/AppHeader";
import AppSidebar from "../../Layout/AppSidebar";
import PageTitle from "../../Layout/AppMain/PageTitle";
import {useTranslation} from "react-i18next";
import {shopsReloadShopStart} from "../../actions/Shops";

import {IonPage, IonContent,} from '@ionic/react';
import CommonHeader from '../../Components/CommonHeader';


const Common = (
    {
        activeShop,
        shopsReloadShopStart
    }
) => {
    const {t, i18n} = useTranslation();
    return <>
        <IonPage>
            <CommonHeader
                title='Settings'
            />
            <IonContent className="ion-padding">

                <APIForm2
                    apiPath='shop/shops'
                    modelId={activeShop.id}
                    schemaPath='setting_common_form_schema_mobile'
                    afterSubmitCallback={() => {
                        shopsReloadShopStart();
                    }} emptyMessage={undefined} actionRedirectUrl={undefined} apiFormAfterDeleteCallback={undefined}
                    buttonSubmitDisabled={undefined}/>

            </IonContent>
        </IonPage>
    </>
};

const mapStateToProps = state => ({
    activeShop: state.Shops.activeShop,
});

const mapDispatchToProps = dispatch => ({
    shopsReloadShopStart: () => dispatch(shopsReloadShopStart())
});

export default connect(mapStateToProps, mapDispatchToProps)(Common);
